export default "__VITE_ASSET__DG43doGm__"